import { ERROR_CODES } from '@shinetools/errors';
import LocalizedStrings from 'localized-strings';

const {
  BULK_BANK_TRANSFER_AMOUNT_NOT_IN_EURO,
  BULK_BANK_TRANSFER_AMOUNT_TOO_HIGH,
  BULK_BANK_TRANSFER_FILE_FORMAT_NOT_SUPPORTED,
  BULK_BANK_TRANSFER_FILE_NOT_PARSABLE,
  BULK_BANK_TRANSFER_IBAN_NOT_SEPA,
  BULK_BANK_TRANSFER_IBAN_NOT_VALID,
  BULK_BANK_TRANSFER_INSUFFICIENT_FUNDS,
  BULK_BANK_TRANSFER_LABEL_HAS_SPECIAL_CHAR,
  BULK_BANK_TRANSFER_TOO_MANY_TRANSFERS,
} = ERROR_CODES;

export const globalErrorsLocales = new LocalizedStrings({
  en: {
    [BULK_BANK_TRANSFER_FILE_FORMAT_NOT_SUPPORTED]:
      'The format of your file is not compatible. The accepted formats are XML and CSV. If needed, you can download one of the templates to complete below.',
    [BULK_BANK_TRANSFER_FILE_NOT_PARSABLE]:
      'The information in your document cannot be read. You can download one of the templates below to make sure your document is compatible.',
    [BULK_BANK_TRANSFER_INSUFFICIENT_FUNDS]:
      'The amount available in your bank account does not allow you to make this bulk transfer of {totalAmount}.',
    [BULK_BANK_TRANSFER_TOO_MANY_TRANSFERS]:
      'It contains more than {maxTransfersCount} transfers.',
  },
  fr: {
    [BULK_BANK_TRANSFER_FILE_FORMAT_NOT_SUPPORTED]:
      'Le format de votre fichier n’est pas compatible. Les formats acceptés sont XML et CSV. En cas de besoin, vous pouvez télécharger l’un des modèles à compléter ci-dessous.',
    [BULK_BANK_TRANSFER_FILE_NOT_PARSABLE]:
      'Les informations dans votre document ne peuvent pas être lues.  Vous pouvez télécharger l’un des modèles ci-dessous pour vous assurer de la compatibilité de votre document.',
    [BULK_BANK_TRANSFER_INSUFFICIENT_FUNDS]:
      'Le montant disponible sur votre compte bancaire ne permet pas d’effectuer ce virement groupé d’un montant de {totalAmount}.',
    [BULK_BANK_TRANSFER_TOO_MANY_TRANSFERS]:
      'Il contient plus de {maxTransfersCount} virements.',
  },
} as const);
export const transferErrorLocales = new LocalizedStrings({
  en: {
    [BULK_BANK_TRANSFER_AMOUNT_NOT_IN_EURO]: {
      many: 'The transfers for {recipientNameOrNames} are in a currency other than the euro.',
      one: 'The transfer for {recipientNameOrNames} is in a currency other than the euro.',
    },
    [BULK_BANK_TRANSFER_AMOUNT_TOO_HIGH]: {
      many: 'The amounts of the transfers for {recipientNameOrNames} are over {maxAmount}.',
      one: 'The amount of the transfer for {recipientNameOrNames} is over {maxAmount}.',
    },
    [BULK_BANK_TRANSFER_IBAN_NOT_SEPA]: {
      many: "{recipientNameOrNames}'s IBANs are not compatible with SEPA transfers.",
      one: "{recipientNameOrNames}'s IBAN is not compatible with SEPA transfers.",
    },
    [BULK_BANK_TRANSFER_IBAN_NOT_VALID]: {
      many: "{recipientNameOrNames}'s IBANs contain errors.",
      one: "{recipientNameOrNames}'s IBAN contains an error.",
    },
    [BULK_BANK_TRANSFER_LABEL_HAS_SPECIAL_CHAR]: {
      many: 'The transfer references for {recipientNameOrNames} contain special characters (é,è,€,-).',
      one: 'The transfer reference for {recipientNameOrNames} contains special characters (é,è,€,-).',
    },
  },
  fr: {
    [BULK_BANK_TRANSFER_AMOUNT_NOT_IN_EURO]: {
      many: 'Les virements pour {recipientNameOrNames} sont dans une devise autre que l’euro.',
      one: 'Le virement pour {recipientNameOrNames} est dans une devise autre que l’euro.',
    },
    [BULK_BANK_TRANSFER_AMOUNT_TOO_HIGH]: {
      many: 'Les montants des virements pour {recipientNameOrNames} sont supérieurs à {maxAmount}.',
      one: 'Le montant du virement pour {recipientNameOrNames} est supérieur à {maxAmount}.',
    },
    [BULK_BANK_TRANSFER_IBAN_NOT_SEPA]: {
      many: 'Les IBANs de {recipientNameOrNames} ne sont pas compatibles avec les virements SEPA.',
      one: "L'IBAN de {recipientNameOrNames} n'est pas compatible avec les virements SEPA.",
    },
    [BULK_BANK_TRANSFER_IBAN_NOT_VALID]: {
      many: 'Les IBANs de {recipientNameOrNames} comportent des erreurs.',
      one: "L'IBAN de {recipientNameOrNames} comporte une erreur.",
    },
    [BULK_BANK_TRANSFER_LABEL_HAS_SPECIAL_CHAR]: {
      many: 'Les références des virements pour {recipientNameOrNames} contiennent des caractères spéciaux (é,è,€,-).',
      one: 'La référence du virement pour {recipientNameOrNames} contient des caractères spéciaux (é,è,€,-).',
    },
  },
} as const);
